<template>
  <div>{{ $t("Frequently used list") }}</div>
</template>

<script>
export default {
  components: {},
  props: {},
  emits: [],
  data() {
    return {}
  },
  watch: {},

  created() {},

  methods: {}
}
</script>
